import Swiper from 'swiper';
import {Pagination} from 'swiper/modules';

import '../scss/theme.css';
import '../scss/front-desti.scss';

import './components/back-to-top.js'
import './components/request-offer-form.js'
import './components/main-menu.js'
import './components/phone-input.js'
import 'swiper/css';

import 'swiper/css/pagination';

if (import.meta.hot) {
  import.meta.hot.accept();
}

;(function (_, $) {
    $(document).ready(function(){
      // Initialize Swiper carousels
      new Swiper('.activities-carousel', {
        slidesPerView: 1,
        navigation: false,
        pagination: false,
        loop: false,
        spaceBetween: 16,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });


      // Adding this here since the bundler can't touch the blocks in the current setup.
      // Maybe later?
      new Swiper('.destigo-visual-carousel', {
        modules: [Pagination],
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetAfter: 48,
        slidesPerGroup: 1,
        navigation: false,
        pagination: {
          el: '.destigo-visual-carousel-navigation',
          clickable: true,
        },
      });

    });
})(window, jQuery);
